define.alias("ember-cli-string-helpers/helpers/lowercase", "calendar/helpers/lowercase");